"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMessageLike = isMessageLike;
exports.isToolDefinitionMessage = isToolDefinitionMessage;
const conventions_1 = require("../../conventions");
/** `role`/`content` are the universal message keys; every other container
 * key is provider vocabulary contributed via `messageLikeKeys`. */
function isMessageLike(value) {
    if ("role" in value || "content" in value)
        return true;
    return conventions_1.registeredProviders.some((provider) => {
        for (const key of provider.messageLikeKeys ?? []) {
            if (key in value)
                return true;
        }
        return false;
    });
}
/** Tool-definition messages fold: shapes only a convention can recognize. */
function isToolDefinitionMessage(message) {
    return conventions_1.registeredProviders.some((provider) => provider.isToolDefinitionMessage?.(message) ?? false);
}
